// A marketing report is now a tab of its edition's page. This route stays only
// so links to the old standalone report page still open the right report.

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/marketing-report/$editionId")({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/admin/editions/$editionId",
			params: { editionId: params.editionId },
			search: { tab: "report" },
		});
	},
});
